export default __webpack_public_path__ + "static/media/excellent.a0358b53.jpg";